<template>

  <component :is="layout">
    <nav class="navbar navbar-top navbar-expand-md navbar-dark" id="navbar-main">
      <div class="container-fluid">
        <a class="h4 mb-0 text-white text-uppercase d-none d-lg-inline-block" href="#">
          <i class="fas fa-coins"></i> {{ $i18n.t('global.coins') }}
        </a>

        <ul class="navbar-nav align-items-center d-none d-md-flex">
          <li class="nav-item dropdown">
            <a class="nav-link pr-0" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <div class="media align-items-center">
                <span v-if="user" class="photoURL avatar avatar-sm rounded-circle" :style="{ 'background-image': 'url('+user.photoURL+')' }">
                </span>
                <div class="media-body ml-2 d-none d-lg-block">
                  <span class="mb-0 text-sm  font-weight-bold">{{ user ? user.displayName : '' }}</span>
                </div>
              </div>
            </a>
            <div class="dropdown-menu dropdown-menu-arrow dropdown-menu-right">
              <Menu key="Coin" />
            </div>
          </li>
        </ul>

      </div>
    </nav>

    <div class="header bg-gradient-primary pb-7 pt-5 pt-md-6"></div>

    <div class="container-fluid mt--7" v-if="coin">

      <div class="row mt-5">
        <div class="col-xl-4 order-xl-2 mb-5 mb-xl-0">
          <div class="card card-profile shadow">
            <div class="row justify-content-center">
              <div class="col-lg-3 order-lg-2">
                <div class="card-profile-image">
                  <img :src="coin.image" :alt="coin.title" class="rounded-circle">
                </div>
              </div>
            </div>
            <div class="card-body pt-0 pt-md-4">
              <div class="text-center mt-8">
                <h3> <i>{{ coinEdit.title }}</i> </h3>
                <div class="h5 font-weight-300">
                  <span v-if="coin.country">
                    <img :src="'https://www.countryflags.io/'+coin.country.toLowerCase()+'/flat/24.png'" :alt="coin.country">
                    {{ $i18n.t('countries.' + coin.country) }},
                  </span>
                  {{ $i18n.t('continents.' + coin.continent) }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-8 order-xl-1">
          <div class="card bg-secondary shadow">
            <div class="card-header bg-white border-0">
              <div class="row align-items-center">
                <div class="col-8">
                  <h3 class="mb-0">{{ $i18n.t('coins.edit') }}</h3>
                </div>
                <div class="col-4 text-right">
                  <button @click="updateCoin()" class="btn btn-sm btn-primary">{{ $i18n.t('global.save') }}</button>
                  <button @click="$router.replace({ name: 'coin.show', params: { key: $route.params.key } })" class="btn btn-sm btn-primary">{{ $i18n.t('global.cancel') }}</button>
                </div>
              </div>
            </div>
            <div class="card-body">
              <form>
                <h6 class="heading-small text-muted mb-4">{{ $i18n.t('coins.info') }}</h6>
                <div class="pl-lg-4">
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="form-group focused">
                        <label class="form-control-label" for="title">{{ $i18n.t('global.coin') }}</label>
                        <input v-model="coinEdit.title" type="text" ref="title" class="form-control form-control-alternative">
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="form-group focused">
                        <label class="form-control-label" for="title">{{ $i18n.t('global.description') }}</label>
                        <textarea v-model="coinEdit.description" rows="4" class="form-control form-control-alternative"></textarea>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="form-group focused">
                        <label class="form-control-label" for="quantity">{{ $i18n.t('global.quantity') }}</label>
                        <input v-model="coinEdit.quantity" type="number" min="0" ref="quantity" class="form-control form-control-alternative">
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group focused">
                        <label class="form-control-label" for="year">{{ $i18n.t('global.year') }}</label>
                        <input v-model="coinEdit.year" type="number" min="0" ref="year" class="form-control form-control-alternative">
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="form-group focused">
                        <label class="form-control-label" for="book">{{ $i18n.t('global.book') }}</label>
                        <div class="dropdown full-width">
                          <button class="btn btn-secondary dropdown-toggle full-width bg-white" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <span v-if="coinEdit.book">
                              <i class="fas fa-book"></i> {{ coinEdit.book.name }}
                            </span>
                            <span v-else>
                              {{ $i18n.t('coins.none') }}
                            </span>
                          </button>
                          <div class="dropdown-menu full-width" aria-labelledby="dropdownMenuButton">
                            <a @click.prevent="selectBook(book)" class="dropdown-item full-width" href="#" v-for="(book, index) in books" :key="'book'+index">{{ book.name }}</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr class="my-4">
                <!-- Images -->
                <h6 class="heading-small text-muted mb-4">{{ $i18n.t('global.images') }}</h6>
                <div class="pl-lg-4">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group focused">

                        <div class="text-center mb-3">
                          <button @click="addImage()" type="button" class="btn btn-primary">
                            <i class="fas fa-plus"></i> {{ $i18n.t('global.add') }}
                          </button>
                        </div>
                        <table class="table align-items-center table-flush">
                          <thead class="thead-light">
                            <tr>
                              <th scope="col">{{ $i18n.t('global.image') }}</th>
                              <th scope="col">URL</th>
                              <th scope="col"></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(image, index) in coinEdit.images">
                              <th scope="row" :key="index">
                                <div class="media align-items-center">
                                  <a href="#" class="avatar rounded-circle mr-3">
                                    <img :src="image.src">
                                  </a>
                                </div>
                              </th>
                              <td>
                                <input v-model="coinEdit.images[index].src" type="text" ref="images[]" class="form-control form-control-alternative">
                              </td>
                              <td class="text-right">
                                <div class="dropdown">
                                  <a class="btn btn-sm btn-icon-only text-light" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <i class="fas fa-ellipsis-v"></i>
                                  </a>
                                  <div class="dropdown-menu dropdown-menu-right dropdown-menu-arrow">
                                    <a @click.prevent="removeImage(index)" class="dropdown-item" href="#"><i class="fas fa-trash-alt"></i> {{ $i18n.t('global.delete') }}</a>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>

                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>

          </div>
        </div>
      </div>

      <Footer />

    </div>
  </component>

</template>

<script>
import Footer from '../../layouts/Footer'
import Modal from '../../layouts/Modal'
import Menu from '../../layouts/Menu'
import { Carousel, Slide } from 'vue-carousel'

export default {
  name: 'CoinShow',
  components: { Footer, Modal, Carousel, Slide, Menu },
  data () {
    return {
      coinEdit: {}
    }
  },
  computed: {
    layout () {
      return 'Layout'
    },
    books () {
      return this.$store.getters.books
    },
    user () {
      return this.$store.getters.user
    },
    coin () {
      let coin = this.$store.getters.coin
      this.coinEdit = coin
      return coin
    }
  },
  created () {
    this.$store.dispatch('fetchUser')
    this.$store.dispatch('fetchBooks')
    this.$store.dispatch('fetchCoin', { key: this.$route.params.key })
  },
  methods: {
    selectBook (book) {
      this.coinEdit.book = book
    },
    addImage () {
      this.coinEdit.images.push({ src: '' })
    },
    removeImage (index) {
      this.coinEdit.images.splice(index, 1)
    },
    updateCoin () {
      let key = this.$route.params.key
      if (this.user) {
        this.coinEdit.book = this.coinEdit.book.id
        this.coinEdit.image = this.coinEdit.images[0].src
        this.coinEdit.quantity = parseInt(this.coinEdit.quantity)
        this.coinEdit.year = this.coinEdit.year ? parseInt(this.coinEdit.year) : null
        this.coinEdit.updated_at = new Date().toISOString()
        this.$store.dispatch('updateCoin', { data: this.coinEdit, key: key }).then(() => {
          window.location.href = '/coins/show/' + key
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Coin/CoinEdit.vue